import React, { useEffect, useState } from "react";

export const DownloadList = (props) => {
  return (
    <div id="download-list" className="download-list text-center section-title">
      <h2>Downloads</h2>
      <p>
        Click on an item below to download it. If you have any issues, please
        contact me.
      </p>
      <ul className="list-unstyled">
        {props.data
          ? props.data.map((d, i) => (
              <li key={`${d.name}-${i}`} className="download-item">
                <i className={d.icon}></i>
                <a
                  href={`/downloads/${d.file}`}
                  download={d.file}
                  className="btn btn-outline-primary"
                >
                  <h5>{d.name}</h5>
                </a>
              </li>
            ))
          : "loading"}
      </ul>
    </div>
  );
};
